export { default } from './query-gallery.tsx';